export const resetPassword = {
    title: 'Đặt lại mật khẩu',
    newPassword: 'Mật khẩu mới',
    confirmNewPassword: 'Nhập lại mật khẩu mới',
    resetSuccess: 'Bạn đã đặt lại mật khẩu thành công',
    buttonSave: 'Lưu',
};
